export const getAuthRedirect = (to, isLoggedIn) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  return requiresAuth && !isLoggedIn ? '/login' : null;
};
